import { useEffect, useState } from "react";
import axios from "../lib/api";
/**
 * this file for creating data that need to be mapped to put in dropdwon menus
 * like Suppliers and Governotes
 * mapDataToUi function @param {Array} data the fetched data that will mapped to ui
 * useMapDataToUi @returns data to list in dropdwon
 */
export const mapDataToUi = (data) => {
    let result = [];
    if (data) {
        const keys = Object.keys(data);
        keys.forEach((key) => {
            result.push({
                value: data[key].id,
                label:
                    data[key].attributes.nameAr ||
                    data[key].attributes.name ||
                    data[key].attributes.alias ||
                    data[key].attributes.plateNumber ||
                    data[key].attributes.email,
            });
        });
    }
    return result;
};

export const useMapDataToUi = (entityName, body, inEntities) => {
    const [data, setData] = useState([]);
    useEffect(() => {
        const fetchData = async () => {
            await axios.get(`/${entityName}`, body).then((res) => {
                setData(mapDataToUi(res?.entities?.[inEntities || entityName]));
            });
        };
        const controller = new AbortController();
        fetchData();
        return () => {
            controller.abort();
        };
    }, []);
    return data;
};

export const useMapDataToUiWithFilter = (entityName, inEntities) => {
    const [data, setData] = useState([]);
    const [searchFilter, setSearchFilter] = useState("");
    const [isValuesReturned, setIsValuesReturned] = useState(true);

    const clearSearchFilter = () => {
        setSearchFilter("");
    };

    const fetchData = async () => {
        try {
            const response = await axios.get(`/${entityName}`, {
                params: {
                    ...(searchFilter && { "filter[q]": searchFilter }),
                },
            });
            const newData = mapDataToUi(response?.entities?.[inEntities || entityName]);
            if (searchFilter && newData.length === 0) {
                setIsValuesReturned(false);
            } else {
                setIsValuesReturned(true);
            }
            setData(newData);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    useEffect(() => {
        fetchData();
    }, [searchFilter]);
    return { data, setSearchFilter, clearSearchFilter, isValuesReturned };
};

export const getAllGovernorates = async (filter) => {
    const response = await axios.get("/governorates", {
        params: {
            ...(filter && { "filter[q]": filter }),
        },
    });
    return mapDataToUi(response.entities.governorates);
};
export const getAllSuppliers = async (filter) => {
    const response = await axios.get("/suppliers", {
        params: {
            ...(filter && { "filter[name]": filter }),
        },
    });
    return mapDataToUi(response.entities.suppliers);
};
